import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const GeneralFile: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[34px] h-[40px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="40"
    viewBox="0 0 34 40"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3.99C0 2.93179 0.420374 1.91691 1.16864 1.16864C1.91691 0.420374 2.93179 0 3.99 0H23.275L33.25 9.975V35.91C33.25 36.9682 32.8296 37.9831 32.0814 38.7314C31.3331 39.4796 30.3182 39.9 29.26 39.9H3.99C2.93179 39.9 1.91691 39.4796 1.16864 38.7314C0.420374 37.9831 0 36.9682 0 35.91V3.99Z"
      fill="url(#paint0_linear_1492_2624)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.98047 14.1312V12.4702H22.9425V14.1322H7.98047V14.1312ZM17.9555 15.7942H7.98047V17.4562H17.9555V15.7942ZM7.98047 20.7802H22.9425V19.1202H7.98047V20.7822V20.7802Z"
      fill="#CFCFCF"
    />
    <path
      d="M26.6242 9.9651C26.191 9.9651 25.762 9.87976 25.3619 9.71396C24.9617 9.54816 24.598 9.30514 24.2918 8.99879C23.9855 8.69244 23.7426 8.32875 23.5769 7.9285C23.4112 7.52825 23.326 7.09929 23.3262 6.6661V0.0581055L33.2462 9.9651H26.6242Z"
      fill="#DBDBDB"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1492_2624"
        x1="0"
        y1="0"
        x2="0"
        y2="39.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#DBDBDB" />
      </linearGradient>
    </defs>
  </svg>
);

export default GeneralFile;
